
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import {  getAllActivityByEstablishmentAPI,GetActivityByIdAPI,postRegisterActivityAPI,putUpdateActivityAPI
    ,deleteActivityDataByIdAPI,  
getRepositoriesAPI,postRepositoriesAPI,deleteRepositoriesAPI,getPDFRepositoriesAPI, getTransformationFactorsActivityByActivityIdAPI,
postImportActivityDataExcelAPI
    } from "src/services/restcall";
import { ActivitiesSource } from "src/store/activity/types";


//postImportActivityDataExcelAPI


export const postImportActivityDataExcel = (file:File,id:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postImportActivityDataExcelAPI(file,id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","Archivo "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const postRepositories = (month:string,id:string,file:File): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postRepositoriesAPI(month,id,file);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","Archivo "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getPDFRepositories = (value:string,activityDataId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPDFRepositoriesAPI(value,activityDataId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));          
        window.open(responseData.Response.url, '_blank');     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getRepositories = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getRepositoriesAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const deleteRepositories = (value:string,value2:string): AppThunk => async (dispatch) => {    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteRepositoriesAPI(value,value2);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        openNotification("Advertencia",message.message[0]);      
        
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Archivo",validateMessages.deleteSuccess);      
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const deleteActivityDataById = (value:String): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteActivityDataByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        openNotification("Advertencia",message.message[0]);      
        
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Data de actividad",validateMessages.deleteSuccess);      
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getAllActivityByEstablishment = (value:String): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllActivityByEstablishmentAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const GetActivityById = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetActivityByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const GetTransformationFactorsActivityByActivityId = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getTransformationFactorsActivityByActivityIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};



export const postResgistActivity = (value:ActivitiesSource): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postRegisterActivityAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","Data actividad "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};



export const putUpdateActivity = (value:ActivitiesSource): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putUpdateActivityAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Data actividad "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
